import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';

const CategoryFeed = ({ pool }: { pool: Article[] }) => {
  const [active, setActive] = useState('all');

  const filtered = useMemo(
    () => (active === 'all' ? pool : pool.filter((item) => item.categorySlug === active)),
    [active, pool],
  );

  const tabs = [{ slug: 'all', name: '全部' }, ...categories];

  return (
    <section aria-labelledby="feed-title" className="flex flex-col gap-5">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 id="feed-title" className="font-heading text-2xl font-black text-foreground-950">
            分类内容流
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            按栏目切换，查看近期最活跃的爆料与现场记录
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const isActive = active === tab.slug;
            return (
              <button
                key={tab.slug}
                type="button"
                onClick={() => setActive(tab.slug)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-600 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900'
                }`}
              >
                {tab.name}
              </button>
            );
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {filtered.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>

      {active !== 'all' && (
        <div className="flex justify-center">
          <Link
            to={`/category/${active}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-4 py-2 text-sm text-primary-800 transition-colors hover:bg-primary-100"
          >
            查看该栏目全部内容
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      )}
    </section>
  );
};

export default CategoryFeed;